<template>
    <AppLayout>
        <div class="col-12 layout-spacing">
            <div class="widget widget-six">
                <div class="widget-heading"></div>
                <div class="widget-content">
                    <div class="row mb-4 g-2 align-items-end">
                        <div class="col-12 col-sm-2 col-md-2">
                            <label class="form-label d-none d-md-block">Rok</label>
                            <select v-model="selectedYearInternal" @change="changePeriod" class="form-select">
                                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                            </select>
                        </div>
                        <div class="col-12 col-sm-2 col-md-2">
                            <label class="form-label d-none d-md-block">Miesiąc</label>
                            <select v-model="selectedMonthInternal" @change="changePeriod" class="form-select">
                                <option value="0">Wszystkie</option>
                                <option v-for="(name, index) in months" :key="index" :value="index+1">{{ name }}</option>
                            </select>
                        </div>
                        <div class="col-12 col-sm-2 col-md-2">
                            <label class="form-label d-none d-md-block">Szukaj</label>
                            <input v-model="search" type="text" placeholder="Szukaj..." class="form-control" />
                        </div>
                        <div class="col-12 col-sm-2 col-md-2">
                            <label class="form-label d-none d-md-block">Na stronę</label>
                            <select v-model="perPage" @change="changePerPage" class="form-select">
                                <option v-for="opt in perPageOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered table-striped table-hover">
                            <thead>
                                <tr>
                                    <th @click="sortBy('faktura_numer')">Numer faktury</th>
                                    <th @click="sortBy('data_sprzedazy')">Data sprzedaży</th>
                                    <th @click="sortBy('data_utworzenia')">Data utworzenia</th>
                                    <th @click="sortBy('waluta')">Waluta</th>
                                    <th @click="sortBy('customer_name')">Klient</th>
                                    <th @click="sortBy('nip')">NIP</th>
                                    <th @click="sortBy('projekt')">Projekt</th>
                                    <th @click="sortBy('info')">Opis</th>
                                    <th>Opcje</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="faktura in paginatedFaktury" :key="faktura.id">
                                    <td>
                                        {{ faktura.faktura_numer }}<br>
                                    </td>
                                    <td class="align-items-center">{{ faktura.data_sprzedazy }}</td>
                                    <td class="align-items-center">{{ faktura.data_utworzenia }}</td>
                                    <td class="align-items-center">{{ faktura.waluta }}</td>
                                    <td>{{ faktura.customer_name }}</td>
                                    <td>{{ faktura.nip }}</td>
                                    <td>{{ faktura.projekt }}</td>
                                    <td>{{ faktura.info }}</td>
                                     <td class="align-items-center">
                                        <a :href="faktura.faktura_upo" target="_blank" class="btn btn-info btn-sm ms-2 mb-2 me-2">
                                            <i class="bi bi-file-earmark-pdf"></i>Pobierz
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                        <div class="mb-2">
                            <button class="btn btn-outline-secondary btn-sm me-1" :disabled="page <= 1" @click="goToPage(page-1)">
                                « Poprzednia
                            </button>
                            <button
                                v-for="p in pageNumbers"
                                :key="p"
                                class="btn btn-sm me-1"
                                :class="p === page ? 'btn-primary' : 'btn-outline-secondary'"
                                @click="goToPage(p)">
                                {{ p }}
                            </button>
                            <button class="btn btn-outline-secondary btn-sm" :disabled="page >= lastPage" @click="goToPage(page+1)">
                                Następna »
                            </button>
                        </div>
                        <div class="mb-2">
                            Strona {{ page }} / {{ lastPage }} | Łącznie {{ total }} rekordów
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script>
    import AppLayout from "@/Layouts/App.vue";
    import axios from "axios";
	
    export default {
        components: {AppLayout},
        props: {
            selectedYear: Number,
            selectedMonth: Number,
        },

        data() {
            return {
                allFaktury: [],
                filteredFaktury: [],
                search: "",
                sortKey: localStorage.getItem("faktury_sortKey") || "data_utworzenia",
                sortAsc: localStorage.getItem("faktury_sortAsc") === "false" ? false : true,
                selectedYearInternal: this.selectedYear,
                selectedMonthInternal: this.selectedMonth,
                page: 1,
                perPage: 50,
                total: 0,
                perPageOptions: [{
                        label: '25 wyników',
                        value: 25
                    },
                    {
                        label: '50 wyników',
                        value: 50
                    },
                    {
                        label: '100 wyników',
                        value: 100
                    },
                    {
                        label: 'Wszystkie',
                        value: 0
                    }
                ],
                years: [new Date().getFullYear(), new Date().getFullYear() - 1, new Date().getFullYear() - 2],
                months: [
                    "Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec",
                    "Lipiec", "Sierpień", "Wrzesień", "Październik", "Listopad", "Grudzień"
                ],
            };
        },

        computed: {
            paginatedFaktury() {
                if (this.perPage === 0) return this.filteredFaktury;
                const start = (this.page - 1) * this.perPage;
                return this.filteredFaktury.slice(start, start + this.perPage);
            },

            lastPage() {
                if (this.perPage === 0) return 1;
                return Math.ceil(this.filteredFaktury.length / this.perPage);
            },

            pageNumbers() {
                const numbers = [];
                const start = Math.max(this.page - 2, 1);
                const end = Math.min(start + 4, this.lastPage);
                for (let i = start; i <= end; i++) numbers.push(i);
                return numbers;
            }
        },

        watch: {
            search() {
                this.applyFilters();
            }
        },

        methods: {
            async fetchFaktury() {
                try {
                    const res = await axios.get("/warehouse/faktury/get", {
                        params: {
                            year: this.selectedYearInternal,
                            month: this.selectedMonthInternal || null,
                        }
                    });
                    this.allFaktury = res.data.data.map(f => ({
                        ...f,
                        printed: Number(f.printed) || 0 
                    }));

                    this.total = this.allFaktury.length;
                    this.applyFilters();

                } catch (error) {
                    console.error("Błąd pobierania faktur:", error);
                }
            },

            applyFilters() {
                let f = [...this.allFaktury];
                if (this.search) {
                    const s = this.search.toLowerCase();
                    f = f.filter(x =>
                        (x.faktura_numer && x.faktura_numer.toLowerCase().includes(s)) ||
                        (x.customer_name && x.customer_name.toLowerCase().includes(s)) ||
                        (x.waluta && x.waluta.toLowerCase().includes(s)) ||
                        (x.data_sprzedazy && x.data_sprzedazy.includes(s)) ||
                        (x.data_utworzenia && x.data_utworzenia.includes(s)) ||
                        (x.nip && x.nip.includes(s)) ||
                        (x.info && x.info.toLowerCase().includes(s)) ||
                        (x.projekt && x.projekt.toLowerCase().includes(s))
                    );
                }
                if (this.sortKey) {
                    f.sort((a, b) => {
                        let valA = a[this.sortKey] ?? "";
                        let valB = b[this.sortKey] ?? "";
                        if (this.sortKey === "data_sprzedazy" || this.sortKey === "data_utworzenia") {
                            const parseDate = (str) => {
                                if (!str) return new Date(0);
                                const [day, month, year] = str.split(".");
                                return new Date(year, month - 1, day);
                            };

                            valA = parseDate(valA);
                            valB = parseDate(valB);
                        }
                        else if (typeof valA === "string") {
                            valA = valA.toLowerCase();
                            valB = valB.toLowerCase();
                        }
                        if (valA < valB) return this.sortAsc ? -1 : 1;
                        if (valA > valB) return this.sortAsc ? 1 : -1;
                        return 0;
                    });
                }
                this.filteredFaktury = f;
                this.page = 1;
            },

            sortBy(key) {
                if (this.sortKey === key) this.sortAsc = !this.sortAsc;
                else {
                    this.sortKey = key;
                    this.sortAsc = true;
                    this.sortKey = key;
                }
                localStorage.setItem("faktury_sortKey", this.sortKey);
                localStorage.setItem("faktury_sortAsc", this.sortAsc);
                this.applyFilters();
            },

            changePeriod() {
                this.page = 1;
                this.fetchFaktury();
            },

            changePerPage() {
                this.page = 1;
            },

            goToPage(page) {
                if (page < 1 || page > this.lastPage) return;
                this.page = page;
            },

            showToast(icon, title, message) {
                Toast.fire({
                    position: 'top-end',
                    toast: true,
                    icon: icon,
                    title: title,
                    html: message,
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    },
                    timer: 1500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    showCloseButton: true
                });
            },

        },

        mounted() {
            this.fetchFaktury();
        }
    };
</script>

<style scoped>
    .table th {
        cursor: pointer;
    }
</style>